import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "atoms/utils/createDerivedSessionAtom";
import { createPersistedAtom } from "atoms/utils/createPersistedAtom";

const sessionFirstNamePhAtom = atomFamily((sessionId: string) => createPersistedAtom(`firstNamePh-${sessionId}`, ""));
export const firstNamePhAtom = createDerivedSessionAtom<string>(sessionFirstNamePhAtom);

const sessionLastNamePhAtom = atomFamily((sessionId: string) => createPersistedAtom(`lastNamePh-${sessionId}`, ""));
export const lastNamePhAtom = createDerivedSessionAtom<string>(sessionLastNamePhAtom);

const sessionPersonalCodePhAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`personalCodePh-${sessionId}`, "")
);
export const personalCodePhAtom = createDerivedSessionAtom<string>(sessionPersonalCodePhAtom);
